// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3GTAP","checkboxCol":"Table_checkboxCol__3FR6w","emailCol":"Table_emailCol__1qPRx","actionCol":"Table_actionCol__2X4PR"};